import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';

@Component({
  selector: 'slotcom-pending-rewards',
  templateUrl: './pending-rewards.component.html',
  styleUrls: ['./pending-rewards.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, ParagraphComponent, ButtonComponent],
})
export class PendingRewardsModalComponent {
  pendingRewardsModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);

  close() {
    this.eventManager.closeModal(
      new Modal(this.pendingRewardsModalData.id, ModalType.Persisted, this.pendingRewardsModalData, '', false)
    );
  }
}
